import React from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import useAuth from '../../../hooks/useAuth'
import axios from '../../../lib/axios'
import MoveRight from '../../../assets/icons/MoveRight'

const Sip = () => {
    const { auth } = useAuth()
    const { t } = useTranslation()

    const { data: partnerrights } = useQuery<PartnerRight[] | null>({
        queryKey: [`partnerrights_${auth.data?.partner}`],
        queryFn: async () => {
            try {
                if (!auth.data?.partner) { return null; }
                const { data } = await axios.post(`partnerrights`, {
                    token: auth.data?.token,
                    partnerid: auth.data?.partner,
                })
                if (data.errorcode !== 0) { throw new Error(data.message) }
                if (!data.object.right) { return null; }
                return data.object.right
            } catch (error) {
                console.log(error)
                return null
            }
        },
        enabled: !!auth.data,
        refetchOnWindowFocus: false
    })

    const hasRight = (right: keyof UserRight) => {
        if (partnerrights && !partnerrights[0][right as keyof PartnerRight]) return false;
        return !!auth.data?.right[right];
    }

    return (
        <div className='overflow-auto relative w-full p-4 md:p-8'>
            <h1 className="text-2xl font-semibold mb-4 md:mb-8">{t("sip.title")}</h1>

            <div className="mt-4 md:mt-8 grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-4">
                {hasRight('sipexecutedinterventions') &&
                    <Link to="uitgevoerde-interventies">
                        <div className='group flex justify-between items-center gap-4 shadow-sm border rounded-sm p-4 hover:border-primary'>
                            <div>
                                <h3 className='font-semibold'>{t("sip.title_interventions")}</h3>
                                <p className='text-sm text-neutral-500'>{t("sip.description_interventions")}</p>
                            </div>
                            <MoveRight className='text-neutral-400 group-hover:translate-x-1 group-hover:text-primary duration-200' />
                        </div>
                    </Link>
                }

                {hasRight('sipmanagements') &&
                    <Link to="beheer-atm">
                        <div className='group flex justify-between items-center gap-4 shadow-sm border rounded-sm p-4 hover:border-primary'>
                            <div>
                                <h3 className='font-semibold'>{t("sip.title_atm")}</h3>
                                <p className='text-sm text-neutral-500'>{t("sip.description_atm")}</p>
                            </div>
                            <MoveRight className='text-neutral-400 group-hover:translate-x-1 group-hover:text-primary duration-200' />
                        </div>
                    </Link>
                }

                {hasRight('sipassets') &&
                    <Link to="assets">
                        <div className='group flex justify-between items-center gap-4 shadow-sm border rounded-sm p-4 hover:border-primary'>
                            <div>
                                <h3 className='font-semibold'>{t("sip.title_assets")}</h3>
                                <p className='text-sm text-neutral-500'>{t("sip.description_assets")}</p>
                            </div>
                            <MoveRight className='text-neutral-400 group-hover:translate-x-1 group-hover:text-primary duration-200' />
                        </div>
                    </Link>
                }

                {hasRight('sipplanninginterventions') &&
                    <Link to="planning-interventies">
                        <div className='group flex justify-between items-center gap-4 shadow-sm border rounded-sm p-4 hover:border-primary'>
                            <div>
                                <h3 className='font-semibold'>{t("sip.title_planning")}</h3>
                                <p className='text-sm text-neutral-500'>{t("sip.description_planning")}</p>
                            </div>
                            <MoveRight className='text-neutral-400 group-hover:translate-x-1 group-hover:text-primary duration-200' />
                        </div>
                    </Link>
                }

                {hasRight('e2eservice') &&
                    <Link to="beheer-e2e">
                        <div className='group flex justify-between items-center gap-4 shadow-sm border rounded-sm p-4 hover:border-primary'>
                            <div>
                                <h3 className='font-semibold'>{t("sip.title_e2e")}</h3>
                                <p className='text-sm text-neutral-500'>{t("sip.description_e2e")}</p>
                            </div>
                            <MoveRight className='text-neutral-400 group-hover:translate-x-1 group-hover:text-primary duration-200' />
                        </div>
                    </Link>
                }
            </div>
        </div>
    )
}

export default Sip